import Vue from "vue";
import Router from "vue-router";
import Realtime from "@/views/Read";
import Index from "@/views/Index";
import Layout from "@/views/Layout";
import WiseBrain from "@/views/WiseBrain";
import Product from "@/views/Product";
import Solution from "@/views/Solution";
import News from "@/views/News";
import About from "@/views/About";
import Join from "@/views/Join";
//import SolutionDetail from '@/views/SolutionDetail'
import SolutionDetail1 from "@/views/SolutionDetail1";
import SolutionDetail2 from "@/views/SolutionDetail2";
import SolutionDetail3 from "@/views/SolutionDetail3";
import SolutionDetail4 from "@/views/SolutionDetail4";
import SolutionDetail5 from "@/views/SolutionDetail5";
import SolutionDetail6 from "@/views/SolutionDetail6";
import SolutionDetail7 from "@/views/SolutionDetail7";
import SolutionDetail8 from "@/views/SolutionDetail8";
import NewsDetail from "@/views/NewsDetail";
import NewsDetail1 from "@/views/NewsDetail1";
import NewsDetail2 from "@/views/NewsDetail2";
import NewsDetail3 from "@/views/NewsDetail3";
import JoinDetail from "@/views/JoinDetail";
import Test from "@/views/Test";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    /*
    {
      path: '/',
      name: 'home',
      component: Index,
      meta: {
        requireAuth: true
      },
    },
    */
    {
      path: "/",
      name: "Layout",
      redirect: "/Index",
      component: Layout,
      children: [
        {
          path: "/Index",
          name: "Index",
          component: Index
        },
        {
          path: "/WiseBrain",
          name: "WiseBrain",
          component: WiseBrain
        },
        {
          path: "/Product",
          name: "Product",
          component: Product,
          meta: {
            title: '产品页标题',  // 标题
            keywords: '产品关键词',  // 直接传递关键词
            description: '产品页描述'  // 直接传递描述
          }
        },
        {
          path: "/Solution",
          name: "Solution",
          component: Solution
        },
        {
          path: "/SolutionDetail1",
          name: "SolutionDetail1",
          component: SolutionDetail1
        },
        {
          path: "/SolutionDetail2",
          name: "SolutionDetail2",
          component: SolutionDetail2
        },
        {
          path: "/SolutionDetail3",
          name: "SolutionDetail3",
          component: SolutionDetail3
        },
        {
          path: "/SolutionDetail4",
          name: "SolutionDetail4",
          component: SolutionDetail4
        },
        {
          path: "/SolutionDetail5",
          name: "SolutionDetail5",
          component: SolutionDetail5
        },
        {
          path: "/SolutionDetail6",
          name: "SolutionDetail6",
          component: SolutionDetail6
        },
        {
          path: "/SolutionDetail7",
          name: "SolutionDetail7",
          component: SolutionDetail7
        },
        {
          path: "/SolutionDetail8",
          name: "SolutionDetail8",
          component: SolutionDetail8
        },
        {
          path: "/News",
          name: "News",
          component: News
        },
        {
          path: "/NewsDetail",
          name: "NewsDetail",
          component: NewsDetail
        },
        {
          path: "/NewsDetail1",
          name: "NewsDetail1",
          component: NewsDetail1
        },
        {
          path: "/NewsDetail2",
          name: "NewsDetail2",
          component: NewsDetail2
        },
        {
          path: "/NewsDetail3",
          name: "NewsDetail3",
          component: NewsDetail3
        },
        {
          path: "/About",
          name: "About",
          component: About
        },
        {
          path: "/Join",
          name: "Join",
          component: Join
        },
        {
          path: "/JoinDetail",
          name: "JoinDetail",
          component: JoinDetail
        },
        {
          path: "/Test",
          name: "Test",
          component: Test
        }
      ]
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js